const translations = {
  title: "Workshop — Active Job Cards",
  subtitle: "Track active manufacturing jobs, metal issues, receipts, and losses.",
  jobCards: "Job Cards",
  newJobCard: "New Job Card",
  jobCardNo: "Job Card No.",
  jobCardDetail: "Job Card Detail",
  jobCardNotFound: "Job card not found.",
  allJobCards: "All Job Cards",
  // Filters
  searchPlaceholder: "Search by job no, karigar, item…",
  filterByStatus: "Filter by status",
  filterByKarigar: "Filter by karigar",
  allStatuses: "All statuses",
  allKarigars: "All karigars",
  // Status badges
  status_open: "Open",
  status_gold_issued: "Gold Issued",
  status_in_progress: "In Progress",
  status_received: "Received",
  status_qc_passed: "QC Passed",
  status_qc_failed: "QC Failed",
  status_closed: "Closed",
  status_cancelled: "Cancelled",
  // Fields
  karigar: "Karigar",
  karigarName: "Karigar Name",
  assignedTo: "Assigned To",
  itemName: "Item Name",
  category: "Category",
  orderNo: "Order No.",
  orderRef: "Order Reference",
  priority: "Priority",
  priority_normal: "Normal",
  priority_high: "High",
  priority_urgent: "Urgent",
  expectedDelivery: "Expected Delivery",
  targetGrossWeight: "Target Gross Wt (g)",
  targetFineGold: "Target Fine Gold (g)",
  purity: "Purity",
  // Actions
  closeJobCard: "Close Job Card",
  printJobCard: "Print Job Card",
  sendEmail: "Send Email to Karigar",
  // Empty states
  noJobCards: "No job cards yet.",
  createFirstJob: "Create the first job card to begin manufacturing.",
  // QC
  qcCheck: "Quality Check",
  qcPassed: "QC Passed",
  qcFailed: "QC Failed",
  qcNotes: "QC Notes",
  // Columns
  col_jobNo: "Job No.",
  col_karigar: "Karigar",
  col_item: "Item",
  col_purity: "Purity",
  col_issued: "Issued",
  col_received: "Received",
  col_balance: "Balance",
  col_status: "Status",
  col_delivery: "Delivery",
  col_action: "Action",
};

export default translations;
